<template>
  <div class="app-content-back container mx-auto">
    <div
      v-if="session"
      class="flex flex-row mb-4 text-6xl lg:text-base"
    >
      <span v-if="session">{{ session.date | formatDate }}</span> <span
        class="ml-4 font-semibold"
      >{{ session.title }}</span>
    </div>

    <div class="flex flex-row">
      <div class="w-full">
        <div
          v-if="this.connectError"
          class="text-3xl bg-red-100 border-l-4 border-orange-500 text-orange-700 p-4"
          role="alert"
        >
          <p class="font-bold">
            Keine Verbindung zum Server
          </p>
          <p>Die Anwesenheit konnte nicht gespeichert werden.</p>
        </div>
        <div class="">
          <sc-presence-members
            v-if="members"
            :members="members"
            :session-id="session.id"
            :player-reviews="session.playerReviews"
          />
        </div>
        <div
          v-if="this.connectError"
          class="text-3xl bg-red-100 border-l-4 border-orange-500 text-orange-700 p-4"
          role="alert"
        >
          <p class="font-bold">
            Keine Verbindung zum Server
          </p>
          <p>Die Anwesenheit konnte nicht gespeichert werden.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'Presence',
    data () {
        return {
            session: null,
            team: null,
            members: null,
            connectError: false,
            presentMembers: []
        }
    },

    async mounted () {
        const id = this.$route.params.id
        const response = await apiService.getSsession(id)
        this.session = response.data

        await this.loadTeam(this.session.teamId)
    },
    methods: {
        async toggleMember (member) {
            this.connectError = false

            const old = member.participated

            try {
                if (member.participated) {
                    await apiService.setParticipation(this.session.id, member.id, false, '')
                } else {
                    await apiService.removeParticipation(this.session.id, member.id, false, '')
                }
            } catch {
                console.log('reverting')
                this.connectError = true
                member.participated = old
                const obj = this.members.find(obj => obj.id === member.id)
                obj.participated = false
                this.$forceUpdate()
            }
        },

        async loadTeam (teamId) {
            const response = await apiService.getTeam(teamId)

            var all = response.data.members
            this.session.playerReviews.forEach(function (review) {
                if (review.hasParticipated) {
                    const obj = all.find(obj => obj.id === review.player.id)
                    obj.participated = true
                }
            })

            this.members = response.data.members
            this.team = response.data
        }
    }
}
</script>

<style scoped>

</style>